import { useMemo } from 'react'

import { useFormattedOrgFees } from '@/selectors/organization'

export const usePayoutFee = () => {
  const { data: orgFeeData } = useFormattedOrgFees()
  const formattedFee = useMemo(() => {
    if (!orgFeeData) return ''

    const { baseFee, feePercentage, orgCoversAllFees } = orgFeeData
    if (orgCoversAllFees) return 'Free'
    if (feePercentage) {
      return `${feePercentage} of funds ${baseFee}`
    }
    return `${baseFee} minimum`
  }, [orgFeeData])

  return {
    formattedFee,
  }
}
